import styled from 'styled-components';
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { locale } from 'base/shared/Localization';
import { isDevelopmentEnvironment } from 'base/shared/Env/env';
import Actions from 'datamodel/SearchFilters/actions';
import { getPublicAsset } from 'base/shared/Utils';
import { translate } from 'base/shared/Localization';

const Container = styled.div`
  background: #fcf6ed !important;
  padding: 4rem 0rem;
  min-height: 100vh;
  border-radius: 14px;
`;

const MainContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    font-size: 2.5rem;
    text-align: center;
  }
`;

const Section = styled.div`
  margin-bottom: 4rem;
  display: grid;
  grid-template-columns: ${(props) => (props.reverse ? '1fr 1fr' : '1fr 1fr')};
  gap: 3rem;
  align-items: center;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const LargeImageContainer = styled.div`
  width: 100%;
  height: 350px;
  background-image: url(${({ imageName }) => getPublicAsset(`v2/images/${imageName}.png`)});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 1rem;

  @media (max-width: 768px) {
    height: 280px;
  }
`;

const TextContent = styled.div`
  padding: 1rem 0;
`;

const SectionTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1.5rem;
`;

const SectionText = styled.p`
  font-size: 1rem;
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const SmallImagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const SmallImageContainer = styled.div`
  width: 100%;
  height: 400px;
  background-image: url(${({ imageName }) => getPublicAsset(`v2/images/${imageName}.png`)});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 0.5rem;
`;

const TwoImagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top: 1rem;
`;

const MediumImageContainer = styled.div`
  width: 100%;
  height: 400px;
  background-image: url(${({ imageName }) => getPublicAsset(`v2/images/${imageName}.png`)});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 0.75rem;
`;

const ExploreButton = styled.button`
  background-color: #283618;
  color: white;
  border: none;
  border-radius: 0.5rem;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 1.5rem;
  min-width: 160px;

  &:hover {
    transform: translateY(-2px);
  }
`;

const FindRoomButton = styled.button`
  background-color: #283618;
  color: white;
  border: none;
  border-radius: 0.5rem;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: block;
  margin: 3rem auto 0;
  min-width: 160px;

  &:hover {
    transform: translateY(-2px);
  }
`;

function WhyBadiPlus({ router, setMarketplaceSegmentsFilters }) {
  const currentLocale = locale();
  const isDev = isDevelopmentEnvironment();

  const handleExploreRooms = () => {
    setMarketplaceSegmentsFilters({
      filters: {
        badiRooms: true,
        badiCommunity: false,
      },
    });

    const baseUrl = isDev ? '' : 'https://badi.com';
    const localePath = currentLocale === 'en' ? '' : `/${currentLocale}`;
    const searchPath = '/s/Barcelona--Espa%C3%B1a';
    const queryParams =
      '?et-search-sorting=relevance&et-search-source=search-bar&marketplaceSegmentBadiRooms=true&bounds=41.4682974272428%2C2.22804492421789%3B41.31703848925413%2C2.052333262952554&center=41.3873974%2C2.168568&d=11.164609446567885&city=Barcelona&pid=ChIJ5TCOcRaYpBIRCmZHTz37sEQ&z=12';

    const fullUrl = `${baseUrl}${localePath}${searchPath}${queryParams}`;

    router.push(fullUrl);
  };

  const handleFindRoom = () => {
    setMarketplaceSegmentsFilters({
      filters: {
        badiRooms: true,
        badiCommunity: false,
      },
    });

    const baseUrl = isDev ? '' : 'https://badi.com';
    const localePath = currentLocale === 'en' ? '' : `/${currentLocale}`;
    const searchPath = '/s/Barcelona--Espa%C3%B1a';
    const queryParams =
      '?et-search-sorting=relevance&et-search-source=search-bar&marketplaceSegmentBadiRooms=true&bounds=41.4682974272428%2C2.22804492421789%3B41.31703848925413%2C2.052333262952554&center=41.3873974%2C2.168568&d=11.164609446567885&city=Barcelona&pid=ChIJ5TCOcRaYpBIRCmZHTz37sEQ&z=12';

    const fullUrl = `${baseUrl}${localePath}${searchPath}${queryParams}`;

    router.push(fullUrl);
  };

  return (
    <Container>
      <MainContent>
        <Title>{translate('v2.whyBadiPlus.title')}</Title>

        {/* Design & Location Section */}
        <Section>
          <LargeImageContainer imageName="why-badi-plus-1" />
          <TextContent>
            <SectionTitle>{translate('v2.whyBadiPlus.designLocation.title')}</SectionTitle>
            <SectionText>{translate('v2.whyBadiPlus.designLocation.text1')}</SectionText>
            <SectionText>{translate('v2.whyBadiPlus.designLocation.text2')}</SectionText>
          </TextContent>
        </Section>

        {/* Peace of mind Section */}
        <Section reverse>
          <TextContent>
            <SectionTitle>{translate('v2.whyBadiPlus.peaceOfMind.title')}</SectionTitle>
            <SectionText>{translate('v2.whyBadiPlus.peaceOfMind.text1')}</SectionText>
            <SectionText>{translate('v2.whyBadiPlus.peaceOfMind.text2')}</SectionText>
            <ExploreButton onClick={handleExploreRooms}>
              {translate('v2.whyBadiPlus.peaceOfMind.button')}
            </ExploreButton>
          </TextContent>
          <div>
            <SmallImagesGrid>
              <SmallImageContainer imageName="why-badi-plus-2" />
              <SmallImageContainer imageName="why-badi-plus-3" />
              <SmallImageContainer imageName="why-badi-plus-4" />
            </SmallImagesGrid>
          </div>
        </Section>

        {/* The heart of a home Section */}
        <Section>
          <LargeImageContainer imageName="why-badi-plus-5" />
          <TextContent>
            <SectionTitle>{translate('v2.whyBadiPlus.heartOfHome.title')}</SectionTitle>
            <SectionText>{translate('v2.whyBadiPlus.heartOfHome.text1')}</SectionText>
            <SectionText>{translate('v2.whyBadiPlus.heartOfHome.text2')}</SectionText>
          </TextContent>
        </Section>

        {/* Creativity and inspiration Section */}
        <Section reverse>
          <TextContent>
            <SectionTitle>{translate('v2.whyBadiPlus.creativity.title')}</SectionTitle>
            <SectionText>{translate('v2.whyBadiPlus.creativity.text1')}</SectionText>
            <SectionText>{translate('v2.whyBadiPlus.creativity.text2')}</SectionText>
          </TextContent>
          <div>
            <TwoImagesGrid>
              <MediumImageContainer imageName="why-badi-plus-6" />
              <MediumImageContainer imageName="why-badi-plus-7" />
            </TwoImagesGrid>
          </div>
        </Section>

        {/* Natural light Section */}
        <Section>
          <LargeImageContainer imageName="why-badi-plus-8" />
          <TextContent>
            <SectionTitle>{translate('v2.whyBadiPlus.naturalLight.title')}</SectionTitle>
            <SectionText>{translate('v2.whyBadiPlus.naturalLight.text1')}</SectionText>
            <SectionText>{translate('v2.whyBadiPlus.naturalLight.text2')}</SectionText>
          </TextContent>
        </Section>

        <FindRoomButton onClick={handleFindRoom}>
          {translate('v2.whyBadiPlus.findRoom.button')}
        </FindRoomButton>
      </MainContent>
    </Container>
  );
}

const mapDispatchToProps = (dispatch) => ({
  setMarketplaceSegmentsFilters: (filters) =>
    dispatch(Actions.setMarketplaceSegmentsFilters(filters)),
});

export default connect(null, mapDispatchToProps)(withRouter(WhyBadiPlus));
